<!-- splash screen -->
<!-- <div #splashScreen id="splash-screen">
  <img src="../../../../../../assets/media/logos/IA_BW.png" alt="Logo" style="width: 250px;" />
  <svg class="splash-spinner" viewBox="0 0 50 50">
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
  </svg>
</div> -->


<div #splashScreen id="splash-screen">
<div id="splash-screen" class="splash-screen">
  <img src="./assets/media/logos/IA_Color.png" alt="hydratight logo" style="width: 250px;" />
  <div class="snippet" data-title=".dot-spin">
    <div class="stage">
      <div class="dot-spin"></div>
    </div>
  </div>
</div>
</div>
